@if (isLoading) {
  <app-loading></app-loading>
}

@if (!isLoading) {
  <app-layout
    [user]="user"
    [currentPage]="currentPage$ | async"
    (onNavigate)="onNavigate($event)"
    >
    <router-outlet></router-outlet>
  </app-layout>
}
